module.exports = __webpack_public_path__ + "img/placeholder6-opti.a740547e.png";